import { LinearProgress, useGetList, useRecordContext } from 'react-admin';
import { NoDataSection } from '../NoDataSection';
import { Typography } from '@mui/material';

export const ProductCard = ({ product, compactView }: any) => {
    if (compactView) {
        return (
            <div>
                <Typography>
                    <div style={{ display: 'flex' }}>
                        Amount:&nbsp;
                        <strong>
                            <span>₹</span>
                            {product.amount}
                        </strong>
                    </div>
                </Typography>
                <Typography>
                    <div style={{ display: 'flex' }}>
                        Discount:&nbsp;
                        <strong>
                            <span>₹</span>
                            {product.discount || 0}
                        </strong>
                    </div>
                </Typography>
                <Typography>
                    <div style={{ display: 'flex' }}>
                        Delivery Amount:&nbsp;
                        <strong>
                            <span>₹</span>
                            {product.delivery_amount || 0}
                        </strong>
                    </div>
                </Typography>
                <Typography>
                    <div style={{ display: 'flex' }}>
                        Final Amount:&nbsp;
                        <strong>
                            <span>₹</span>
                            {product.amount -
                                (product.discount || 0) +
                                (product.delivery_amount || 0)}
                        </strong>
                    </div>
                </Typography>
            </div>
        );
    }
    return (
        <div>
            <div style={{ display: 'flex' }}>
                {<img src={product.images?.[0]} style={{ marginRight: '10px' }} width={200} />}
                <div>
                    <Typography>
                        <div style={{ display: 'flex' }}>
                            Product:&nbsp;
                            <strong>
                                <span>₹</span>
                                {product.name}
                            </strong>
                        </div>
                    </Typography>

                    <Typography>
                        <div style={{ display: 'flex' }}>
                            Amount:&nbsp;
                            <strong>
                                <span>₹</span>
                                {product.amount}
                            </strong>
                        </div>
                    </Typography>
                    <Typography>
                        <div style={{ display: 'flex' }}>
                            Available Quantity:&nbsp;
                            <strong>
                                <span>₹</span>
                                {product.available_quantity}
                            </strong>
                        </div>
                    </Typography>
                    <Typography>
                        <div style={{ display: 'flex' }}>
                            Discount:&nbsp;
                            <strong>
                                <span>₹</span>
                                {product.discount || 0}
                            </strong>
                        </div>
                    </Typography>
                    <Typography>
                        <div style={{ display: 'flex' }}>
                            Delivery Amount:&nbsp;
                            <strong>
                                <span>₹</span>
                                {product.delivery_amount || 0}
                            </strong>
                        </div>
                    </Typography>

                    <Typography>
                        <div style={{ display: 'flex' }}>
                            GST Percentage:&nbsp;
                            <strong>
                                <span>₹</span>
                                {product.gst_percentage || 0}
                            </strong>
                        </div>
                    </Typography>

                    <Typography>
                        <div style={{ display: 'flex' }}>
                            Height in Mtr.:&nbsp;
                            <strong>
                                <span>₹</span>
                                {product.height_in_mtr || 0}
                            </strong>
                        </div>
                    </Typography>
                    {/* {<ProgramProductEditButton product={product} />} */}
                </div>
            </div>
            {<Typography dangerouslySetInnerHTML={{ __html: product.html_description }} />}
        </div>
    );
};
